export const customSortPoNo = (rowA, rowB) => {
    const poNoA = rowA.original.poNo.props.children || ""; 
    const poNoB = rowB?.original?.poNo?.props?.children || ""; 
    return poNoA.localeCompare(poNoB);
  };

  export const customSortInvoiceNo = (rowA, rowB) => {
    const inNoA = rowA.original.inNo.props.children || ""; 
    const inNoB = rowB?.original?.inNo?.props?.children || ""; 
    return inNoA.localeCompare(inNoB);
  };

  export const customSortInvoiceDate = (rowA, rowB) => {
    const dateA = new Date(rowA.original.invoiceDate.props.children) || new Date(); 
    const dateB = new Date(rowB.original.invoiceDate.props.children) || new Date(); 
    return dateA - dateB; 
  };
 
  export const customSortPFInvoiceNo = (rowA, rowB) => {
    const inNoA = rowA.original.pfiNo.props.children || ""; 
    const inNoB = rowB?.original?.pfiNo?.props?.children || ""; 
    return inNoA.localeCompare(inNoB);
  };
export const customSortPurchaseDate = (rowA, rowB) => {
    const dateA = new Date(rowA.original.purchasedate.props.children) || new Date(); 
    const dateB = new Date(rowB.original.purchasedate.props.children) || new Date(); 
    return dateA - dateB; 
};
export const customSortDate = (rowA, rowB) => {
  const dateA = new Date(rowA.original.date.props.children) || new Date(); 
  const dateB = new Date(rowB.original.date.props.children) || new Date(); 
  return dateA - dateB; 
};
  
export const customSortApprovedAmount = (rowA, rowB) => {
    const valueA = rowA.original.sortApdAmt || 0;
    const valueB = rowB.original.sortApdAmt || 0;
    return valueA - valueB; 
  };
  
export const customSortSpentAmount = (rowA, rowB) => {
    const valueA = rowA.original.sortSpentAmt || 0;
    const valueB = rowB.original.sortSpentAmt || 0;
  
    return valueA - valueB; 
  };
export const customSortApprovalAmount = (rowA, rowB) => {
    const valueA = rowA.original.sortReqAmt || 0;
    const valueB = rowB.original.sortReqAmt || 0;
  
    return valueA - valueB; 
};

export const customSortTotalAmount = (rowA, rowB) => {
    const valueA = rowA.original.sortTlAmt || 0;
    const valueB = rowB.original.sortTlAmt || 0;
  
    return valueA - valueB; 
};
export const genericSort = (rowA, rowB, accessor) => {
    const valueA = rowA.original[accessor].props.children || "";
    const valueB = rowB.original[accessor].props.children || "";

    const numA = Number(valueA);
    const numB = Number(valueB);

    if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
    } else {
        return valueA.localeCompare(valueB);
    }
};

export const sortBySellPrice = (rowA, rowB) => {
  const valueA = rowA.original.sortSellPrice || 0;
  const valueB = rowB.original.sortSellPrice || 0;

  return valueA - valueB; 
};

export const sortByBaseAmount = (rowA, rowB) => {
  const valueA = rowA.original.sortBaseAmt || 0;
  const valueB = rowB.original.sortBaseAmt || 0;

  return valueA - valueB; 
};
export const sortByIgst = (rowA, rowB) => {
  const valueA = rowA.original.sortIgstAmt || 0;
  const valueB = rowB.original.sortIgstAmt || 0;

  return valueA - valueB; 
};
export const sortByCgst = (rowA, rowB) => {
  const valueA = rowA.original.sortCgstAmt || 0;
  const valueB = rowB.original.sortCgstAmt || 0;

  return valueA - valueB; 
};
export const sortBySgst = (rowA, rowB) => {
  const valueA = rowA.original.sortSgstAmt || 0;
  const valueB = rowB.original.sortSgstAmt || 0;

  return valueA - valueB; 
};

export const customSortCrNo = (rowA, rowB) => {
  const crNoA = rowA.original.crNo.props.children || ""; 
  const crNoB = rowB.original.crNo.props.children || ""; 
  return crNoA.localeCompare(crNoB);
};
export const sortByUseAmt = (rowA, rowB) => {
  const valueA = rowA.original.sortUseAmt || 0;
  const valueB = rowB.original.sortUseAmt || 0;

  return valueA - valueB; 
};
export const sortByRemAmt = (rowA, rowB) => {
  const valueA = rowA.original.sortRemAmt || 0;
  const valueB = rowB.original.sortRemAmt || 0;

  return valueA - valueB; 
};
